var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect, _rect2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path8, _path9, _path10, _rect3, _rect4, _rect5, _rect6, _rect7, _path11, _path12, _g15, _g16, _g17, _g18, _g19, _g20, _path13, _path14, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g21, _g22, _g23, _g24, _g25, _g26, _path15, _path16, _path17, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _g27, _path18, _path19, _path20, _g28, _path21, _path22, _g29, _path23, _path24, _path25, _g30, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileappdev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_463",
    "data-name": "Group 463",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.497,
    height: 70.502,
    viewBox: "0 0 68.497 70.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 68.497,
    height: 70.502
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M28.659,17.751a2.449,2.449,0,0,0-.19.19l-.019.019h0a2.291,2.291,0,0,0-.56,1.5V77.372a2.3,2.3,0,0,0,1.815,2.246H64.093a2.313,2.313,0,0,0,1.524-1.125,2.3,2.3,0,0,1-1.121.292H31.071a2.3,2.3,0,0,1-2.3-2.3V18.58a2.291,2.291,0,0,1,.56-1.5Z",
    transform: "translate(-27.89 -17.08)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 37.722,
    height: 62.542
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 342 571"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342,
    height: 571,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAO8AAADyAAAA+z/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAjsBVgMBIgACEQEDEQH/xABeAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAABABAQAAAAAAAAAAAAAAAAAAkLARAQAAAAAAAAAAAAAAAAAAALASAQAAAAAAAAAAAAAAAAAAAJD/2gAMAwEAAhEDEQAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/2gAIAQIAAQUARj//2gAIAQMAAQUARj//2gAIAQEAAQUAoMf/2gAIAQICBj8ARj//2gAIAQMCBj8ARj//2gAIAQEBBj8AQY//2Q=="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-4",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 342 571"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342,
    height: 571,
    xlinkHref: "data:image/jpeg;base64,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"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 342 571"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342,
    height: 571,
    xlinkHref: "data:image/jpeg;base64,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"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M1.987,39.03A1.986,1.986,0,0,0,0,41.017v8.868a1.986,1.986,0,0,0,1.987,1.987H24.946a1.986,1.986,0,0,0,1.987-1.987V41.017a1.986,1.986,0,0,0-1.987-1.987Z",
    transform: "translate(0 -39.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 26.937,
    height: 12.841
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-6",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 246 121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 246,
    height: 121,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAHIAAAB1AAAAfb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkA9gMBIgACEQEDEQH/xABeAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAABABAQAAAAAAAAAAAAAAAAAAcIARAQAAAAAAAAAAAAAAAAAAAIASAQAAAAAAAAAAAAAAAAAAAHD/2gAMAwEAAhEDEQAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/2gAIAQIAAQUAAP/aAAgBAwABBQAA/9oACAEBAAEFALw//9oACAECAgY/AAD/2gAIAQMCBj8AAP/aAAgBAQEGPwB4f//Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-9",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 246 121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 246,
    height: 121,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAKXAAADAAAAA67/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkA9gMBIgACEQEDEQH/xACSAAEBAQEBAAAAAAAAAAAAAAAABQQGAwEBAQEBAQAAAAAAAAAAAAAAAAECAwQQAAAEBgEEAwEAAAAAAAAAAAABNAUgMEAxAjIDERIEFRBQFCIRAAEDAgUCBwAAAAAAAAAAAAEgAnJAsQAREqLiEzNQITFBUWGBEgABAwUBAAAAAAAAAAAAAAABAEBxMBEhMZFw/9oADAMBAAIRAxEAAADs/Lwyds0k1VLXCrZu4cqAAAAAAAAAAABGya8noyFitJrYu4cdAAAAAAAAAAAARsmvJ6MhYrSa2LuHHQAAAAAAAAAAAEbJryejIWK0mti7hx0AAAAAAAAAAABGya8noyFitJrYu4cdAAAAAAAAAAAARsmvJ6MhYrSa2LuHHQAAAAAAAAAAAEbJryejIWK0mti7hx0AAAAAAAAAAABGydI755t0izm625mhx0AAAAAAAAAAAB//2gAIAQIAAQUAxwxMuzEZ4kRTcdRyazcdRyazcdRyazcdRyazcdRyazcdRyazcevT+hn17Zv/2gAIAQMAAQUAMzHUwRzjuCvNO4K807grzTuCvNO4K807grzT+Cnf/9oACAEBAAEFAPJcPz8vtx7ce3Htx4nk/p46lzVQNSepc1UDUnqXNVA1J6lzVQNSepc1UDUnqXNVA1J6lzVQNSepc1UDUnqXNVA1J6lzVQNSepc1UDUnqXNVA1J6lzVQNSepc1UDUn+4/9oACAECAgY/AAbLSuBWEMBDAQwEMBDAQwGB1aHVkCt//9oACAEDAgY/APAP/9oACAEBAQY/AOn09XkDnqy9fzHZ3ccdndxx2d3HHZ3ccF+nRk7Tlnn7A/XzVGIS6Zs2qMQl0zZtUYhLpmzaoxCXTNm1RiEumbNqjEJdM2bVGIS6Zs2qMQl0zZtUYhLpmzaoxCXTNm1RiEumbNqjEJdM2bVGIS6Zs2qMQl0zZvjP/9k="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-10",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 246 121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 246,
    height: 121,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAALFAAADUwAABDb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkA9gMBIgACEQEDEQH/xACTAAEBAQEBAQEAAAAAAAAAAAAABQMEAQIHAQEBAQEAAAAAAAAAAAAAAAAAAQIDEAABAQYHAQEAAAAAAAAAAAAAASBAMQIDFDARIRIyNAUQBBEAAAMJAAECBwEAAAAAAAAAAAECIEBxobHB4TJyEWESUDFBUSKCAzMSAQEAAQUBAAAAAAAAAAAAAAAxARAwYHARIf/aAAwDAQACEQMRAAAA/QAAOTrlam/3P1263Ijrcg63IOtyDrcg63IOtyDrcg63IOtyDrcg63KKo50BKqytzHXLXpAgAAAAAAAAAD0FUcdAJVWVuY65a9IEAAAAAAAAAAegqjjoBKqytzHXLXpAgAAAAAAAAAD0FUcdAJVWVuY65a9IEAAAAAAAAAAegqjjoBKqytzHXLXpAgAAAAAAAAAD0FUcdAJVWVuY65a9IEAAAAAAAAAAegqjjoBKqtSJrWdJJVkslWElWElWElWElWElWElWElWElWElWEpVH//aAAgBAgABBQD5IiKqyym1DahtQ2obUNqG1DahtQ2obUNqfafJcenyXHp8lx6fJcenyXHp8lx5OS5mpqampqampqampqan/9oACAEDAAEFAPimZmZmZmZmZmZmZmZmf1YY6wx1hjrDHWGOsMdcb//aAAgBAQABBQBn9X7repL6O4vi+L4vi+L4vi+L4vi+L4vi+L4vi+L4vi+L4vi+E/bmjPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWDPqdmm8SwZ9Ts03iWD/wD/2gAIAQICBj8A08yiIiIiIiInI/iY3f/aAAgBAwIGPwDoD//aAAgBAQEGPwBkv5+z3eU+7z58fUy+3oP8/H7YGk8DSeBpPA0ngaTwNJ4Gk8DSeBpPA0ngaTwNJ4Gk8DSeBpPA0ngaTwNJ4Gk8DSeBpPA0ngaTwD/D5euGk8FVTyqFyaTwVVPKoXJpPBVU8qhcmk8FVTyqFyaTwVVPKoXJpPBVU8qhcmk8FVTyqFyaTwVVPKoXJpPBVU8qhcmk8FVTyqFyaTwVVPKoXJpPBVU8qhcmk8FVTyqFyaTwVVPKoXL4B//Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M19.287,92.24A1.986,1.986,0,0,0,17.3,94.227v8.868a1.986,1.986,0,0,0,1.987,1.987H39.152a1.986,1.986,0,0,0,1.987-1.987V94.227a1.986,1.986,0,0,0-1.987-1.987Z",
    transform: "translate(-17.3 -92.24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 23.844,
    height: 12.841
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-11",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 221 117"
  }, /*#__PURE__*/React.createElement("image", {
    width: 221,
    height: 117,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAG8AAAByAAAAer/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHUA3QMBIgACEQEDEQH/xABeAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAABABAQAAAAAAAAAAAAAAAAAAYIARAQAAAAAAAAAAAAAAAAAAAIASAQAAAAAAAAAAAAAAAAAAAGD/2gAMAwEAAhEDEQAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/2gAIAQIAAQUAYf/aAAgBAwABBQBh/9oACAEBAAEFAKk//9oACAECAgY/AGH/2gAIAQMCBj8AYf/aAAgBAQEGPwBSf//Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-15",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 221 117"
  }, /*#__PURE__*/React.createElement("image", {
    width: 221,
    height: 117,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAJHAAACuwAAA5H/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHUA3QMBIgACEQEDEQH/xACBAAEBAQEBAAAAAAAAAAAAAAAAAgMEBgEBAQEBAAAAAAAAAAAAAAAAAAECAxAAAQIHAQEBAQAAAAAAAAAAAAMTMEABETFEBQIyBBQRAAAEBwEBAQAAAAAAAAAAAAABkQJAwTKCwgODERJREgADAQEAAAAAAAAAAAAAAAAAMAFxYP/aAAwDAQACEQMRAAAA9pz7c/WWhZaBaBaBaBaBaBaBaBaBaBaBemGubfP0c9BYAAAAAAAAAAA1y1lvn6OcCwAAAAAAAAAABrlrLfP0c4FgAAAAAAAAAADXLWW+fo5wLAAAAAAAAAAAGuWst8/RzgWAAAAAAAAAAANctZb5+jnAsAAAAAAAAAAAa5ay3zgFgAAAAAAAAAADUl//2gAIAQIAAQUA8/NixYsWLFixYsWLFTz8xKnn5iVPPzEqefmJU8/MSp5+YlTz8xKn/9oACAEDAAEFAI1Y1Y1Y1Y1Y1Y1Y3//aAAgBAQABBQD9/v34q6qOqjqo6qOqjqo6qOqjqo6qOqjqo6qOqjqo6qOqjqo6qOqjqo6qOqjqo6qOqjin83RzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNavRzNav/9oACAECAgY/AI2aRs0jZpGzSNmkbNI2aRs0/9oACAEDAgY/AOw//9oACAEBAQY/ANfw42+/Xvh+fgrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymK3KYrcpitymPr6P37899P3zwarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEarpRfTEf//Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M90.317,67.83a1.986,1.986,0,0,0-1.987,1.987v8.868a1.986,1.986,0,0,0,1.987,1.987h22.959a1.986,1.986,0,0,0,1.987-1.987V69.817a1.986,1.986,0,0,0-1.987-1.987Z",
    transform: "translate(-88.33 -67.83)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-16",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 250,
    height: 121,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAHIAAAB1AAAAfb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkA+gMBIgACEQEDEQH/xABeAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAABABAQAAAAAAAAAAAAAAAAAAcJARAQAAAAAAAAAAAAAAAAAAAJASAQAAAAAAAAAAAAAAAAAAAHD/2gAMAwEAAhEDEQAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/2gAIAQIAAQUAAP/aAAgBAwABBQAA/9oACAEBAAEFAIAf/9oACAECAgY/AAD/2gAIAQMCBj8AAP/aAAgBAQEGPwAAP//Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-20",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 250,
    height: 121,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAKlAAADbgAABKn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAHkA+gMBIgACEQEDEQH/xACHAAEBAQEBAQAAAAAAAAAAAAAABAUDAQYBAQEBAAAAAAAAAAAAAAAAAAABAxAAAgAEBgMBAQAAAAAAAAAAAAMBEwQUQCECEjIzMBExQlARAAEDBQEAAgMAAAAAAAAAAAIAAZEQMXHRMkARQVAhEhIBAAIDAQAAAAAAAAAAAAAAADFBMAGBcP/aAAwDAQACEQMRAAAA+44+zaShOqhOKE4oTihOKE4oTihOKE4oTihOKE4oTihOK683SiKamagsAAAAAAAAAAAAA6aWbpSxTUzAWAAAAAAAAAAAAAdNLN0pYpqZgLAAAAAAAAAAAAAOmlm6UsU1MwFgAAAAAAAAAAAAHTSzdKWKamYCwAAAAAAAAAAAADppZulLFNTMBYAAAAAAAAAAAAB00s3Slkn00ZjTVmNMZjTGY0xmNMZjTGY0xmNMZjTGY0xmNMZjTGY0xmNMZ+gR/9oACAECAAEFANMIetsDbA2wNsDbA2wNsDbA2wNsDbA2wNsDbA9Q96fnm/Wn55v1p+eb9afnm/Wn55v1p+eb9affrMzMzMzMzMzMzMzMzMzM/f8A/9oACAEDAAEFAMBHARwEcBHARwEf4H//2gAIAQEAAQUAqX61ar1petL1petL1petL1petL1petL1petL1petL1petL1petL1petL1petL1petL1petL1petL1oqrZrYV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cV3PG0/cVmjXq1SmkppKaSmkppKaSmkppKaSmkppKaSmkppKaSmkppKaSmkppKaSmkppKaSmkppKaSmkpohbIN/g//2gAIAQICBj8AQhCEIQhCEIQhxrPxrPxrPxrPxrPxrPxSlKUpSlKUpSlKh//aAAgBAwIGPwDwD//aAAgBAQEGPwBmFmf5b7Vhh9qww+1YYfasMPtWGH2rDD7Vhh9qww+1YYfasMPtWGH2rDD7Vhh9qww+1YYfasMPtWGH2rDD7Vhh9qww+1YYfasMPtWGH2rDD7Vhh9qww+1YYfasMPtWGH2hF2H4d/r53Qce4M0HHuDNBx7gzQce4M0HHuDNBx7gzQce4M0HHuDNBx7gzQce4M0HHuDNBx7gzQce4M0H+Rd/19N8rgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodcFDrgodC7gTMz3dn/AAX/2Q=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 19.616,
    height: 1.848
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M11.132,0,9.59,3.589h1.769L12.9,0Z",
    transform: "translate(-5.149)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M16.672,0,15.13,3.589H16.9L18.446,0Z",
    transform: "translate(-8.124)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M22.222,0,20.68,3.589h1.769L23.991,0Z",
    transform: "translate(-11.104)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M27.762,0,26.22,3.589h1.769L29.536,0Z",
    transform: "translate(-14.078)",
    fill: "#942eff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M33.312,0,31.77,3.589h1.769L35.081,0Z",
    transform: "translate(-17.058)",
    fill: "#942eff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M38.852,0,37.31,3.589h1.769L40.626,0Z",
    transform: "translate(-20.033)",
    fill: "#942eff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M44.4,0,42.86,3.589h1.769L46.171,0Z",
    transform: "translate(-23.013)",
    fill: "#942eff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M126.727,26.368h-.1a1.375,1.375,0,0,1-1.38,1.38h-7.317a1.376,1.376,0,0,1-1.38-1.38V21.019a1.376,1.376,0,0,1,1.38-1.38h7.317a1.375,1.375,0,0,1,1.38,1.38v5.348h.2V21.019a1.578,1.578,0,0,0-1.579-1.579h-7.317a1.582,1.582,0,0,0-1.584,1.579v5.348a1.583,1.583,0,0,0,1.584,1.584h7.317a1.579,1.579,0,0,0,1.579-1.584Z",
    transform: "translate(-62.472 -10.438)",
    fill: "#6933a3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 2.913,
    height: 0.773,
    transform: "translate(57.657 12.767)",
    fill: "#140578"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 0.773,
    height: 2.913,
    transform: "translate(58.727 11.697)",
    fill: "#140578"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M10.014,25.019a.746.746,0,1,1,.746-.746.745.745,0,0,1-.746.746m2.718-.352v-.783H11.607a1.711,1.711,0,0,0-.19-.454l.8-.8-.551-.551-.8.8a1.711,1.711,0,0,0-.454-.19V21.56H9.629v1.13a1.711,1.711,0,0,0-.454.19l-.8-.8-.551.551.8.8a1.711,1.711,0,0,0-.19.454H7.3v.783H8.43a1.711,1.711,0,0,0,.19.454l-.8.8.551.551.8-.8a1.711,1.711,0,0,0,.454.19v1.13h.783v-1.13a1.711,1.711,0,0,0,.454-.19l.8.8.551-.551-.8-.8a1.711,1.711,0,0,0,.19-.454Z",
    transform: "translate(-3.92 -11.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M60.975,3.429a.449.449,0,1,1,.449-.449.45.45,0,0,1-.449.449m1.63-.213V2.748h-.676a.952.952,0,0,0-.116-.273L62.294,2l-.333-.333-.482.482a1.1,1.1,0,0,0-.273-.116V1.35h-.468v.676a.952.952,0,0,0-.273.116l-.482-.482-.333.333.482.482a1.1,1.1,0,0,0-.116.273H59.34v.468h.676a.953.953,0,0,0,.116.273l-.482.482.333.333.482-.482a1.1,1.1,0,0,0,.273.116v.676h.468V3.939a.953.953,0,0,0,.273-.116l.482.477.333-.333-.482-.482a1.1,1.1,0,0,0,.116-.273H62.6Z",
    transform: "translate(-31.861 -0.725)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(12.915 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 37.787,
    height: 62.681,
    transform: "translate(-0.018 -0.103)",
    fill: "url(#pattern)"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(12.915 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 37.787,
    height: 62.681,
    transform: "translate(-0.018 -0.103)",
    fill: "url(#pattern)"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(12.915 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 37.787,
    height: 62.681,
    transform: "translate(-0.018 -0.103)",
    fill: "url(#pattern)"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(12.915 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 37.787,
    height: 62.681,
    transform: "translate(-0.018 -0.103)",
    fill: "url(#pattern-4)"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(12.915 7.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 37.787,
    height: 62.681,
    transform: "translate(-0.018 -0.103)",
    fill: "url(#pattern-5)"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M67.814,75.568a2.3,2.3,0,0,1-2.3,2.3H32.1a2.3,2.3,0,0,1-2.3-2.3V17.657a2.3,2.3,0,0,1,2.3-2.3h33.42a2.3,2.3,0,0,1,2.3,2.3Z",
    transform: "translate(-16 -8.247)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M69.417,23.435a.5.5,0,0,1-.5.5h-12.6a.5.5,0,1,1,0-.991h12.6a.493.493,0,0,1,.5.5",
    transform: "translate(-29.977 -12.317)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M91.012,23.006a.866.866,0,1,1-.866-.866.868.868,0,0,1,.866.866",
    transform: "translate(-47.937 -11.888)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(0 18.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-6)"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(0 18.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-6)"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(0 18.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-6)"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(0 18.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-9)"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(0 18.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-10)"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M28.367,48.45a1.986,1.986,0,0,1-1.987,1.987H3.417A1.986,1.986,0,0,1,1.43,48.45V39.587A1.986,1.986,0,0,1,3.417,37.6H26.376a1.986,1.986,0,0,1,1.987,1.987V48.45Z",
    transform: "translate(-0.768 -20.189)",
    fill: "#a8c7fa"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M15.167,51.1,13.75,49.4l1.417-1.7h2.186l-1.417,1.7L17.353,51.1Z",
    transform: "translate(-7.383 -25.612)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M28.419,40.91,26.326,50H24.65l2.1-9.09Z",
    transform: "translate(-13.235 -21.966)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M35.78,47.7h2.186l1.417,1.7L37.966,51.1H35.78L37.2,49.4Z",
    transform: "translate(-19.211 -25.612)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 18.402,
    height: 1.181,
    transform: "translate(30.952 16.244)",
    fill: "#942eff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 7.77,
    height: 1.181,
    transform: "translate(41.588 18.43)",
    fill: "#942eff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 3.149,
    height: 1.181,
    transform: "translate(46.205 24.158)",
    fill: "#942eff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 13.605,
    height: 1.181,
    transform: "translate(35.754 20.815)",
    fill: "#942eff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 12.336,
    height: 1.181,
    transform: "translate(31.771 24.158)",
    fill: "#942eff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M61.881,62.39h-.8v7.988H47.85v8.567h.8V71.179h13.23Z",
    transform: "translate(-25.692 -33.499)",
    fill: "#0d0361"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M77.031,104.82H68.46v.8h7.77v8.673h.8Z",
    transform: "translate(-36.758 -56.281)",
    fill: "#0d0361"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(8.011 42.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 23.894,
    height: 12.892,
    transform: "translate(-0.004 -0.01)",
    fill: "url(#pattern-11)"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(8.011 42.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 23.894,
    height: 12.892,
    transform: "translate(-0.004 -0.01)",
    fill: "url(#pattern-11)"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(8.011 42.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 23.894,
    height: 12.892,
    transform: "translate(-0.004 -0.01)",
    fill: "url(#pattern-11)"
  })))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(8.011 42.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 23.894,
    height: 12.892,
    transform: "translate(-0.004 -0.01)",
    fill: "url(#pattern-11)"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(8.011 42.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 23.894,
    height: 12.892,
    transform: "translate(-0.004 -0.01)",
    fill: "url(#pattern-15)"
  })))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M42.579,101.664a1.986,1.986,0,0,1-1.987,1.987H20.727a1.986,1.986,0,0,1-1.987-1.987V92.8a1.986,1.986,0,0,1,1.987-1.987H40.592A1.986,1.986,0,0,1,42.579,92.8Z",
    transform: "translate(-10.062 -48.759)",
    fill: "#942eff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M32.711,100.081a2.035,2.035,0,0,1,.787.648,2.3,2.3,0,0,1,.4.982H32.341a.812.812,0,0,0-.755-.491A.7.7,0,0,0,31,101.5a1.418,1.418,0,0,0,0,1.51.708.708,0,0,0,.588.278.776.776,0,0,0,.449-.13.9.9,0,0,0,.306-.361H33.9a2.323,2.323,0,0,1-.4.982,2.036,2.036,0,0,1-.787.648,2.544,2.544,0,0,1-1.1.232,2.475,2.475,0,0,1-1.241-.3,2.054,2.054,0,0,1-.81-.852,2.888,2.888,0,0,1,0-2.491,2.054,2.054,0,0,1,.81-.852,2.76,2.76,0,0,1,2.339-.079",
    transform: "translate(-15.721 -53.617)",
    fill: "#fff"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M46.264,103.95h-.991v1.019H43.851V103.95H42.86v-1.357h.991V101.57h1.422v1.023h.991Z",
    transform: "translate(-23.013 -54.536)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M57.058,103.95h-1v1.019H54.646V103.95h-1v-1.357h1V101.57h1.417v1.023h1Z",
    transform: "translate(-28.806 -54.536)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 44.608)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 43.241)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 41.875)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 48.72)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 47.354)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 45.987)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 52.832)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 51.466)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 50.1)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 56.944)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 55.578)",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.449,
    height: 0.764,
    transform: "translate(44.214 54.212)",
    fill: "#fff"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(40.903 31.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-16)"
  })))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(40.903 31.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-16)"
  })))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(40.903 31.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-16)"
  })))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(40.903 31.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-16)"
  })))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(40.903 31.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 27.117,
    height: 12.892,
    transform: "translate(-0.106 -0.043)",
    fill: "url(#pattern-20)"
  })))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M116.692,77.254a1.986,1.986,0,0,1-1.987,1.987H91.747a1.986,1.986,0,0,1-1.987-1.987V68.387A1.986,1.986,0,0,1,91.747,66.4h22.959a1.986,1.986,0,0,1,1.987,1.987Z",
    transform: "translate(-48.195 -35.652)",
    fill: "#e8e5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M100.242,76v2.6a1.47,1.47,0,0,1-.38,1.1,1.446,1.446,0,0,1-1.06.375,1.64,1.64,0,0,1-1.167-.4,1.541,1.541,0,0,1-.435-1.181h1.246a.573.573,0,0,0,.079.343.266.266,0,0,0,.218.1.215.215,0,0,0,.176-.074.4.4,0,0,0,.065-.255V76Z",
    transform: "translate(-52.189 -40.807)",
    fill: "#f2a61c"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M109.345,78.473l-.366-1.121-.366,1.121Zm.306.949h-1.343l-.2.611H106.78L108.257,76h1.459l1.468,4.033H109.85Z",
    transform: "translate(-57.333 -40.807)",
    fill: "#f2a61c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M120.1,76l.829,2.774L121.755,76H123.1l-1.357,4.033h-1.635L118.75,76Z",
    transform: "translate(-63.76 -40.807)",
    fill: "#f2a61c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M133.155,78.473l-.366-1.121-.366,1.121Zm.306.949h-1.343l-.2.611H130.59L132.067,76h1.459l1.468,4.033H133.66Z",
    transform: "translate(-70.118 -40.807)",
    fill: "#f2a61c"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.671,
    height: 0.449,
    transform: "translate(23.056 35.115)",
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.671,
    height: 0.449,
    transform: "translate(21.848 35.115)",
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.671,
    height: 0.449,
    transform: "translate(20.648 35.115)",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.671,
    height: 0.449,
    transform: "translate(26.673 35.115)",
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 0.671,
    height: 0.449,
    transform: "translate(25.469 35.115)",
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.671,
    height: 0.449,
    transform: "translate(24.27 35.115)",
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 0.671,
    height: 0.449,
    transform: "translate(30.294 35.115)",
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 0.671,
    height: 0.449,
    transform: "translate(29.09 35.115)",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 0.671,
    height: 0.449,
    transform: "translate(27.886 35.115)",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 0.449,
    height: 0.82,
    transform: "translate(20.435 36.481)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 0.449,
    height: 0.82,
    transform: "translate(20.435 37.953)",
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 0.449,
    height: 0.82,
    transform: "translate(20.435 39.417)",
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 27.451,
    height: 4.158,
    transform: "translate(19.704 59.963)",
    fill: "#942eff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 19.616,
    height: 1.848,
    transform: "translate(23.098 61.121)",
    fill: "#942eff"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(23.098 61.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M51.325,132.2a.844.844,0,0,1,.292.491h-.463a.41.41,0,0,0-.157-.195.44.44,0,0,0-.25-.069.392.392,0,0,0-.31.139.666.666,0,0,0,0,.75.385.385,0,0,0,.31.139.418.418,0,0,0,.408-.264h.463a.847.847,0,0,1-.292.486.874.874,0,0,1-.57.181.894.894,0,0,1-.463-.116.764.764,0,0,1-.306-.324.992.992,0,0,1-.107-.477,1.063,1.063,0,0,1,.107-.477.825.825,0,0,1,.306-.324.894.894,0,0,1,.463-.116.863.863,0,0,1,.57.176",
    transform: "translate(-49.88 -132.006)",
    fill: "#bf82ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M55.7,132.526a.632.632,0,0,0,0,.755.481.481,0,0,0,.676,0,.625.625,0,0,0,0-.75.437.437,0,0,0-.338-.139.418.418,0,0,0-.338.134m.8-.426a.9.9,0,0,1,.329.329.948.948,0,0,1,.12.477.973.973,0,0,1-.12.477.862.862,0,0,1-.329.329.933.933,0,0,1-.917,0,.862.862,0,0,1-.329-.329.96.96,0,0,1-.12-.477.973.973,0,0,1,.12-.477.862.862,0,0,1,.329-.329.916.916,0,0,1,.458-.12.966.966,0,0,1,.458.12",
    transform: "translate(-52.704 -131.985)",
    fill: "#bf82ff"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M62.278,133.847h-.435l-.727-1.1v1.1H60.68v-1.8h.435l.727,1.111V132.05h.435Z",
    transform: "translate(-32.581 -70.902)",
    fill: "#bf82ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M67.478,133.847h-.435l-.727-1.1v1.1H65.88v-1.8h.435l.727,1.111V132.05h.435Z",
    transform: "translate(-35.373 -70.902)",
    fill: "#bf82ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M71.515,132.393v.38h.607v.329h-.607v.4H72.2v.347H71.08v-1.8H72.2v.343Z",
    transform: "translate(-38.165 -70.902)",
    fill: "#bf82ff"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M76.46,132.2a.844.844,0,0,1,.292.491h-.463a.41.41,0,0,0-.157-.195.44.44,0,0,0-.25-.069.392.392,0,0,0-.31.139.666.666,0,0,0,0,.75.385.385,0,0,0,.31.139.418.418,0,0,0,.408-.264h.463a.847.847,0,0,1-.292.486.874.874,0,0,1-.57.181.865.865,0,0,1-.458-.116.764.764,0,0,1-.306-.324.992.992,0,0,1-.107-.477,1.063,1.063,0,0,1,.107-.477.825.825,0,0,1,.306-.324.888.888,0,0,1,.458-.116.863.863,0,0,1,.57.176",
    transform: "translate(-40.28 -70.885)",
    fill: "#bf82ff"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M81.538,132.05v.343h-.486v1.454h-.44v-1.454H80.13v-.343Z",
    transform: "translate(-43.024 -70.902)",
    fill: "#bf82ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M85.105,132.393v.38h.607v.329h-.607v.4h.685v.347H84.67v-1.8h1.121v.343Z",
    transform: "translate(-45.462 -70.902)",
    fill: "#bf82ff"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M89.757,133.323a.506.506,0,0,0,.144-.38.489.489,0,0,0-.144-.38.555.555,0,0,0-.394-.134h-.208v1.028h.208a.535.535,0,0,0,.394-.134m.468.093a.8.8,0,0,1-.324.32,1.023,1.023,0,0,1-.5.116H88.72v-1.8H89.4a1.049,1.049,0,0,1,.5.111.787.787,0,0,1,.324.315.957.957,0,0,1,.111.468.988.988,0,0,1-.111.472",
    transform: "translate(-47.636 -70.902)",
    fill: "#bf82ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M78.536,4.22c0-.167-.093-.255-.282-.255h-.236v.5h.236c.19,0,.282-.079.282-.245m-.519.621v.676H77.55V3.59H78.3a.728.728,0,0,1,.523.171.607.607,0,0,1,.181.458.653.653,0,0,1-.079.32.608.608,0,0,1-.236.222.814.814,0,0,1-.384.079Z",
    transform: "translate(-41.639 -1.928)",
    fill: "#140578"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M83.876,3.59l-.667,1.287v.639h-.472V4.877L82.07,3.59h.537l.37.787.37-.787Z",
    transform: "translate(-44.066 -1.928)",
    fill: "#140578"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M88.77,3.59v.37h-.523V5.516h-.468V3.96H87.26V3.59Z",
    transform: "translate(-46.852 -1.928)",
    fill: "#140578"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M93.787,3.59V5.516h-.468v-.8h-.732v.8H92.12V3.59h.468v.746h.732V3.59Z",
    transform: "translate(-49.462 -1.928)",
    fill: "#140578"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M98.077,4.109a.578.578,0,0,0-.134.408.587.587,0,0,0,.134.4.459.459,0,0,0,.366.148.464.464,0,0,0,.361-.148.573.573,0,0,0,.134-.4.588.588,0,0,0-.134-.4.459.459,0,0,0-.366-.148.446.446,0,0,0-.361.144m.857-.454a.951.951,0,0,1,.352.352,1.028,1.028,0,0,1,.13.509.993.993,0,0,1-.13.509.918.918,0,0,1-.352.352,1.026,1.026,0,0,1-.982,0,.951.951,0,0,1-.352-.352,1.065,1.065,0,0,1,0-1.019.951.951,0,0,1,.352-.352,1.026,1.026,0,0,1,.982,0",
    transform: "translate(-52.334 -1.895)",
    fill: "#140578"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M105.113,5.516h-.468l-.778-1.181V5.516H103.4V3.59h.468l.778,1.195V3.59h.468Z",
    transform: "translate(-55.518 -1.928)",
    fill: "#140578"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappdev);
export default __webpack_public_path__ + "static/media/mobileappdev.5e65ac828375915db874873dfbc446f5.svg";
export { ForwardRef as ReactComponent };